import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        const user = await googleSession(sessionId);
        const dest = user.role === 'practitioner' ? '/my-studio' : '/dashboard';
        navigate(dest, { replace: true, state: { user } });
      } catch {
        navigate('/login', { replace: true });
      }
    })();
  }, [googleSession, navigate, location.hash]);

  return (
    <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#3A4035] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-[#5C5C55] font-body">Signing you in...</p>
      </div>
    </div>
  );
}
